import apiHandler from '../core/apiHandler';

const restaurantPrinterApi = apiHandler('restaurant');

export default restaurantPrinterApi;
